import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import StorefrontApp from "./App";
import AdminSales from "./AdminSales";
import "./index.css";

function Root() {
  const isAdmin = window.location.pathname.startsWith("/admin/sales");
  return isAdmin ? <AdminSales /> : <StorefrontApp />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Root />
    </HelmetProvider>
  </React.StrictMode>
);